/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overweight`)
};

const es_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrepeso`)
};

const de_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergewicht`)
};

const nl_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overgewicht`)
};

const fr_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surpoids`)
};

const it_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrappeso`)
};

const pt_br2_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acima do peso`)
};

const pt_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excesso de peso`)
};

const ja_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太り気味`)
};

const zh_bmi_cat_overweight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超重`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_cat_overweight = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_cat_overweight(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_cat_overweight", locale)
	if (locale === "en") return en_bmi_cat_overweight(inputs)
	if (locale === "es") return es_bmi_cat_overweight(inputs)
	if (locale === "de") return de_bmi_cat_overweight(inputs)
	if (locale === "nl") return nl_bmi_cat_overweight(inputs)
	if (locale === "fr") return fr_bmi_cat_overweight(inputs)
	if (locale === "it") return it_bmi_cat_overweight(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_cat_overweight(inputs)
	if (locale === "pt") return pt_bmi_cat_overweight(inputs)
	if (locale === "ja") return ja_bmi_cat_overweight(inputs)
	return zh_bmi_cat_overweight(inputs)
};